import { range } from '../../utils/array.utils';

export const generatePaginationOptions = (
  currentPage: number,
  totalPages: number,
  delta = 2,
) => {
  return range(1, totalPages).reduce((pages, page) => {
    // allow adding of first and last pages
    if (page === 1 || page === totalPages) {
      return [...pages, page];
    }

    // if within delta range add page
    if (page - delta <= currentPage && page + delta >= currentPage) {
      return [...pages, page];
    }

    // otherwise add 'gap if gap was not the last item added.
    if (pages[pages.length - 1] !== '...') {
      return [...pages, '...'];
    }

    return pages;
  }, [] as (number | string)[]);
};
